import React, { useState } from "react";
import axios from "axios";

const Register = ({ onClose }) => {
    const [keyword, setKeyword] = useState("");
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [ticketIdFilter, setTicketIdFilter] = useState("");
    const handleAccept = async () => {
        if (!keyword.trim()) return;

        setLoading(true);

        try {
            const response = await axios.post("/tickets/registry", {
                password: keyword.trim(),
            });



            setData(response.data);
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    };

    // Los datos ya vienen agrupados por show desde el backend
    const registry = data?.registry
        ? [...data.registry].sort((a, b) =>
            a.showName.localeCompare(b.showName)
        )
        : [];

    const filteredRegistry = registry
        .map((show) => ({
            ...show,
            tickets: show.tickets?.filter((ticket) =>
                ticketIdFilter.trim()
                    ? String(ticket.id) === ticketIdFilter.trim()
                    : true
            ),
        }))
        .filter((show) => show.tickets?.length > 0);

    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">

            {/* Fondo */}
            <div
                className="absolute inset-0 bg-black/60"
                onClick={onClose}
            />

            {/* Modal */}
            <div
                className="relative bg-[#0C2342] text-white rounded-xl p-4 sm:p-6 shadow-xl w-full max-w-md z-50 overflow-hidden"
                onClick={(e) => e.stopPropagation()}
            >

                {/* Cruz */}
                <button
                    onClick={onClose}
                    className="absolute top-3 right-3 sm:right-4 text-xl text-white/70 hover:text-red-400"
                >
                    ✕
                </button>

                {/* Input */}
                <input
                    type="text"
                    value={keyword}
                    onChange={(e) => setKeyword(e.target.value)}
                    className="w-full box-border bg-white/10 border border-white/10 rounded-lg px-3 py-2.5 text-white text-sm sm:text-base outline-none focus:border-sky-400"
                />

                {/* Aceptar */}
                <div className="flex justify-center mt-4">
                    <button
                        onClick={handleAccept}
                        disabled={loading}
                        className="bg-sky-600 hover:bg-sky-700 disabled:opacity-50 px-5 py-2.5 rounded-lg font-semibold text-sm sm:text-base"
                    >
                        {loading ? "Cargando..." : "Aceptar"}
                    </button>
                </div>



                {/* Datos */}
                {data && (

                    <>
                        <div className="mt-4">
                            <input
                                type="number"
                                value={ticketIdFilter}
                                onChange={(e) => setTicketIdFilter(e.target.value)}
                                placeholder="Numero de entrada"
                                className="w-full box-border bg-white/10 border border-white/10 rounded-lg px-3 py-2 text-white text-sm outline-none focus:border-sky-400"
                            />
                        </div>


                        <div className="mt-5 max-h-[50vh] overflow-y-auto overflow-x-hidden bg-white/5 rounded-lg p-3 sm:p-4">

                            {filteredRegistry.length > 0 ? (
                                filteredRegistry.map((show, showIndex) => (
                                    <div
                                        key={show.showId}
                                        className={`
                                        rounded-xl
                                        border border-sky-400/30
                                        bg-[#102b4d]
                                        overflow-hidden
                                        ${showIndex > 0 ? "mt-8" : ""}
                                    `}
                                    >

                                        {/* ENCABEZADO DEL SHOW */}
                                        <div className="bg-sky-500/10 border-b-2 border-sky-400/40 px-4 py-3">
                                            <div className="flex items-center justify-between gap-2">

                                                <div className="min-w-0">
                                                    <h3 className="text-lg sm:text-xl font-bold text-sky-300 break-words">
                                                        {show.showName}
                                                    </h3>

                                                    <p className="text-xs text-white/50 mt-1">
                                                        Evento #{show.showId}
                                                    </p>
                                                </div>

                                                <span className="text-xs sm:text-sm text-white/60 whitespace-nowrap">
                                                    {show.tickets?.length || 0}{" "}
                                                    {show.tickets?.length === 1
                                                        ? "ticket"
                                                        : "tickets"}
                                                </span>
                                            </div>
                                        </div>

                                        {/* TICKETS DEL SHOW */}
                                        <div className="px-4">
                                            {show.tickets
                                                ?.slice()
                                                .sort((a, b) => a.id - b.id)
                                                .map((ticket) => (
                                                    <div
                                                        key={ticket.id}
                                                        className="border-b border-white/10 py-4 last:border-0"
                                                    >

                                                        {/* ID + PRECIO */}
                                                        <div className="flex justify-between items-center gap-2 mb-2">
                                                            <span className="font-semibold text-white">
                                                                Ticket #{ticket.id}
                                                            </span>

                                                            <span className="text-sm font-semibold text-green-400 whitespace-nowrap">
                                                                ${ticket.price}
                                                            </span>
                                                        </div>

                                                        <p className="text-sm mb-1 break-words">
                                                            <strong className="text-sky-300">
                                                                División:
                                                            </strong>{" "}
                                                            {ticket.division || "-"}
                                                        </p>

                                                        <p className="text-sm mb-1 break-words">
                                                            <strong className="text-sky-300">
                                                                Ubicación:
                                                            </strong>{" "}
                                                            {ticket.location || "-"}
                                                        </p>

                                                        <p className="text-sm mb-1 break-words">
                                                            <strong className="text-sky-300">
                                                                Fecha:
                                                            </strong>{" "}
                                                            {ticket.date || "-"}
                                                        </p>

                                                        <p className="text-sm mb-1">
                                                            <strong className="text-sky-300">
                                                                Fila:
                                                            </strong>{" "}
                                                            {ticket.row ?? "-"}
                                                        </p>

                                                        <p className="text-sm mb-1">
                                                            <strong className="text-sky-300">
                                                                Asiento:
                                                            </strong>{" "}
                                                            {ticket.seat ?? "-"}
                                                        </p>

                                                        <p className="text-sm mb-1 break-words">
                                                            <strong className="text-sky-300">
                                                                Nombre:
                                                            </strong>{" "}
                                                            {ticket.name || "-"}
                                                        </p>

                                                        <p className="text-sm mb-1">
                                                            <strong className="text-sky-300">
                                                                DNI:
                                                            </strong>{" "}
                                                            {ticket.dni || "-"}
                                                        </p>

                                                        <p className="text-sm mb-1 break-words">
                                                            <strong className="text-sky-300">
                                                                Mail:
                                                            </strong>{" "}
                                                            {ticket.mail || "-"}
                                                        </p>

                                                        <p className="text-sm mb-1">
                                                            <strong className="text-sky-300">
                                                                Teléfono:
                                                            </strong>{" "}
                                                            {ticket.phone || "-"}
                                                        </p>

                                                        <p className="text-xs text-white/40 mt-2 break-words">
                                                            Creado:{" "}
                                                            {ticket.createdAt || "-"}
                                                        </p>

                                                    </div>
                                                ))}
                                        </div>

                                    </div>
                                ))
                             ) : (
                                <div className="text-sm text-white/70">
                                    No se encontraron tickets.
                                </div>
                            )}

                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

            export default Register;
